import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=46da7683&scoped=true&"
import script from "./Invitation.vue?vue&type=script&lang=js&"
export * from "./Invitation.vue?vue&type=script&lang=js&"
import style0 from "./Invitation.vue?vue&type=style&index=0&id=46da7683&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46da7683",
  null
  
)

export default component.exports